import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Navbar from './Navbar';
import Footer from './Footer';
import { blogPosts } from '../content/blog/blogList';

const Blog: React.FC = () => {
  return (
    <>
      <Navbar />
      <Container className="py-5 mt-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3">Our Blog</h1>
          <p className="lead text-muted">
            Insights and tips to help grow your home service business
          </p>
        </div>
        
        <Row className="g-4">
          {blogPosts.map((post) => (
            <Col key={post.id} lg={4} md={6}>
              <Card className="h-100 shadow-sm border-0 blog-card">
                {post.image && (
                  <div className="overflow-hidden" style={{ height: '200px' }}>
                    <Card.Img
                      variant="top"
                      src={post.image}
                      alt={post.title}
                      style={{
                        objectFit: 'contain',
                        height: '100%',
                        width: '100%'
                      }}
                    />
                  </div>
                )}
                <Card.Body className="d-flex flex-column">
                  <div className="mb-3">
                    <span className="text-muted small">{post.date}</span>
                    <span className="text-muted small ms-3">{post.readTime}</span>
                  </div>
                  <Card.Title className="h4 mb-3">
                    <Link 
                      to={`/blog/${post.slug}`} 
                      className="text-decoration-none text-dark blog-title"
                    >
                      {post.title}
                    </Link>
                  </Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {post.excerpt}
                  </Card.Text>
                  <div className="mt-3">
                    <Link 
                      to={`/blog/${post.slug}`} 
                      className="btn btn-outline-primary"
                    >
                      Read More →
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default Blog;
